<carm-card class="carm-widget carm-summary-widget">
  <carm-card-title>
    <div class="row">
      <div
      class="col-md-12 inline-content"
      data-cy="financial-homepage-title">
          <span>{{ 'dashboard.widgets.financial.title' | translate }}</span>
          <carm-popover class="mrgn-lft-sm mrgn-tp-sm">
            {{ 'dashboard.widgets.financial.tooltip' | translate }}
          </carm-popover>
      </div>
    </div>
  </carm-card-title>
  <carm-card-content>

    <div class="row mrgn-bttm-0">
      <div class="col-md-6 splitter">
        <div class="row">
          <div
          class="col-md-12 mrgn-tp-sm text-center font-1_3x"
          data-cy="current-amount-due">
            <strong>{{ 'dashboard.widgets.financial.total_net_open_balance' | translate }}</strong>
          </div>
        </div>
        <div class="row" *ngIf="!loading">
          <div class="col-md-12 mrgn-tp-md text-center font-2_5x break-all">
            <strong>{{ currentAmountDue }}</strong>
          </div>
        </div>
        <div class="row" *ngIf="loading" style="max-height: 66px !important;">
          <mat-progress-spinner
          attr.aria-label="{{ 'application_features.loading' | translate }}"
          class="mat-spinner-color spinner-styling"
          mode="indeterminate"
          value="50"
        >
        </mat-progress-spinner>
        </div>
        <div class="row" *carm-acl-group="[carmResourcesEnum.FINANCIAL_STATEMENTS, groupTypeEnum.Reader]">
          <div
          *ngIf="!loading"
          class="col-md-12 mrgn-tp-sm text-center"
          >
            <em><a
              [carmRouterLink]="transactionHistoryUrl"
              data-cy="view-statement-of-accounts">{{ 'dashboard.widgets.financial.view_transactions_history' | translate }}</a></em>
          </div>
        </div>
      </div>
      <div class="col-md-6 mrgn-bttm-0" *carm-acl-group="[carmResourcesEnum.MAKE_PAYMENT, groupTypeEnum.Editor]">
        <div class="row">
          <div
          class="col-md-12 mrgn-tp-sm text-center font-1_3x"
          data-cy="next-payment-due">
            <strong>{{ 'dashboard.widgets.financial.total_overdue_balance' | translate }}</strong>
          </div>
        </div>
        <div class="row" *ngIf="!loading">
          <div class="col-md-12 mrgn-tp-md text-center font-2_5x">
            <strong> {{ totalOverdueBalance }} </strong>
          </div>
        </div>
        <div class="row" *ngIf="loading" style="max-height: 66px !important;">
          <mat-progress-spinner
          attr.aria-label="{{ 'application_features.loading' | translate }}"
          class="mat-spinner-color spinner-styling"
          mode="indeterminate"
          value="50"
        >
        </mat-progress-spinner>
        </div>
        <div class="row" *carm-acl-group="[carmResourcesEnum.MAKE_PAYMENT, groupTypeEnum.Editor]">
          <div
          *ngIf="!loading"
          class="col-md-12 mrgn-tp-sm text-center"
          >
            <em><a
              [carmRouterLink]="makeAPaymentUrl"
              data-cy="make-a-payment">{{ 'dashboard.widgets.financial.make_payment' | translate }}</a></em>
          </div>
        </div>
      </div>
    </div>

  </carm-card-content>
</carm-card>

